import React from "react";
import { IconT } from "types/utils";

const ClockOutlineIcon = ({ height = "17", width = "17", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M10 5v5l3 2M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
        stroke={fill}
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ClockOutlineIcon;
